(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jj-luxe-desserts"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){var button=event.target.closest('[data-treat-filter],[data-dessert-menu-filter]');if(!button)return;var section=button.closest('.jjd-desserts')||document.querySelector('.jjd-desserts');if(!section)return;var selected=button.getAttribute('data-treat-filter')||button.getAttribute('data-dessert-menu-filter');var menu=button.closest('.jjd-menu');if(menu)menu.open=false;section.querySelectorAll('[data-treat-filter]').forEach(function(other){other.setAttribute('aria-pressed',String(other.getAttribute('data-treat-filter')===selected))});section.querySelectorAll('[data-treat-category]').forEach(function(item){item.hidden=selected!=='all'&&item.getAttribute('data-treat-category')!==selected})},true);

function jjChooseTreatFromUrl(){var selected=new URLSearchParams(window.location.search).get('category');if(!selected)return;document.querySelectorAll('.jjd-desserts').forEach(function(section){var button=section.querySelector('[data-treat-filter="'+selected+'"]');if(button)button.click()})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',jjChooseTreatFromUrl)}else{jjChooseTreatFromUrl()}
  } catch(e) { console.error(e); }
})();

})();
